<template>
  <div class="article">
    <div class="search">
      <el-input
        v-model="queryParams.keyword"
        clearable
        placeholder="输入内容标题进行搜索"
        @change="getTitleList(1)"
        prefix-icon="el-icon-search"
      ></el-input>
      <el-button @click="cancel">取消</el-button>
      <el-button @click="confirm" :disabled="canSaveTitle" type="primary">确认</el-button>
    </div>
    <div class="table">
      <el-table
        v-loading="tableLoading"
        ref="singleTable"
        :data="tableData"
        highlight-current-row
        @current-change="chouseChange"
        style="width: 100%"
      >
        <el-table-column label="内容" width="300px">
          <template slot-scope="scope">
            <div class="article-content">
              <el-image
                style="width: 100px; height: 100px"
                :src="scope.row.articleCoverListUrl"
                fit="contain"
              ></el-image>
              <div class="content-right">
                <el-tooltip placement="top" effect="light">
                  <div slot="content">{{ scope.row.articleTitle }}</div>
                  <span class="articleTitle">{{ scope.row.articleTitle }}</span>
                </el-tooltip>

                <span>ID:{{ scope.row.articleId }}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="使用范围" width="200">
          <template>
            <span>辉致头条</span>
          </template>
        </el-table-column>
        <el-table-column property="updateTime" label="操作时间"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryParams.page_index"
        :page-size="queryParams.page_size"
        layout="total,sizes, prev, pager, next, jumper"
        :total="totalVal"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { QueryWxArticleTitleList } from '../../../../api/pointsRule';
export default {
  name: 'Article',
  components: {},
  props: {
    // 编辑时选中的文章ID
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      queryParams: {
        page_index: 1, // 当前页数
        page_size: 10, // 每页条数
        keyword: '', // 关键字
      }, // 列
      tableLoading: false,
      canSaveTitle: true,
      totalVal: 0,
      tableData: [],
      currentRow: {},
    };
  },
  mounted() {},
  methods: {
    getTitleList(type) {
      this.queryParams.page_index = type ? 1 : this.queryParams.page_index;
      this.tableLoading = true;
      this.canSaveTitle = true;
      this.$refs.singleTable.bodyWrapper.scrollTop = 0;
      QueryWxArticleTitleList(this.queryParams)
        .then((res) => {
          const data = res?.articleDataList;
          this.tableData = data;
          this.totalVal = res?.total_num;
          let num = '';
          this.tableData.forEach((item, index) => {
            if (item.articleId === this.id || item.articleId === this.currentRow.articleId) {
              num = index;
            }
          });
          this.$refs.singleTable.setCurrentRow(this.tableData[num]);
          this.tableLoading = false;
        })
        .catch((res) => {
          console.log(res);
          this.tableLoading = false;
        });
    },
    // 每页条数改变
    handleSizeChange(val) {
      this.queryParams.page_size = val;
      this.queryParams.page_index = 1;
      this.getTitleList();
    },
    // 页码改变
    handleCurrentChange(page) {
      this.queryParams.page_index = page;
      this.getTitleList();
    },
    // 选中
    chouseChange(val) {
      this.currentRow = val;
      this.canSaveTitle = !val;
    },
    // 重置参数
    resetPreans() {
      this.tableData = [];
      this.queryParams = {
        page_index: 1, // 当前页数
        page_size: 10, // 每页条数
        keyword: '', // 关键字
      };
      this.currentRow = {};
    },
    // 确认事件
    confirm() {
      this.$emit('chouseAction', this.currentRow);
    },
    // 取消事件
    cancel() {
      this.$emit('chouseCloseDialog');
      this.resetPreans();
    },
  },
};
</script>
<style lang="scss" scoped>
.article {
  width: 100%;
  height: 100%;
  padding-bottom: 30px;
  .search {
    display: flex;
    justify-content: start;
    border-bottom: 1px solid #edeff2;
    height: 56px;
    line-height: 56px;
  }
  .table {
    margin-left: 30px;
    .article-content {
      display: flex;
      .content-right {
        margin-left: 12px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .articleTitle {
          display: inline-block;
          width: 91px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
  .pagination {
    background: #fff;
    height: 60px;
    width: 100%;
    display: flex;
    padding-top: 12px;
    justify-content: flex-end;
    .el-pagination {
      margin-right: 24px;
      ::v-deep .el-input__inner {
        height: 28px;
      }
    }
  }
  ::v-deep .el-input__inner {
    height: 36px;
  }
  .el-input {
    width: 200px;
    margin-right: 10px;
    margin-left: 30px;
  }
  .el-button {
    margin: 10px 10px 0px 10px;
  }
  ::v-deep .el-table__body-wrapper {
    height: 500px;
    overflow-y: scroll;
  }
}
</style>
